
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userActions } from '../actions/userActions';
import * as paymentActions from '../actions/paymentActions';
import * as vehicleActions from '../actions/vehicleActions';
import userLogo from '../../assets/images/username-icon.png';
import passwordLogo from '../../assets/images/password-icon.png';
import { Field, reduxForm, initialize } from 'redux-form';
import ReactGA from 'react-ga';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';







class UserLoginForm extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            accountId:'',
            submitted: false,
            cookiesAccepted: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount(){
        window.addEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: true });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('CookiebotOnAccept', () => {
            this.setState({ cookiesAccepted: false });
        });
    }


    toggle() {      
        this.props.toggle();

    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password,accountId } = this.state;
        if (username && password) {
            this.props.actions.login(username, password,accountId).then(()=>{
                this.props.actions.getUserDetails();
                this.props.paymentActions.getPaymentDetails();
                this.props.vehicleActions.getVehiclesList();
                this.toggle();
            }).catch((error)=>{
                console.log(error);
            });
            
        }
    }



    render(){
        const { loggingIn,logInMultiAccount, error,isOpen } = this.props;
        const { username, password,accountId, submitted } = this.state;

        const hasError = error != "" && error != null;
        return (
            <Modal isOpen={isOpen}
                backdrop={"static"}
                className={"topupModal"}
                toggle={() => this.toggle()}>
                <form onSubmit={this.handleSubmit} >
                    <ModalHeader toggle={() => this.toggle()}>
                        Login with your Easytrip Account
                    </ModalHeader>
                    <ModalBody>
                        <div className={'form-group' + ((submitted && !username) ? ' has-error' : '')}>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><img src={userLogo} /></span>
                                </div>
                                <input type="text" placeholder="Email or Account Number" className="form-control" name="username" value={username} onChange={this.handleChange} />
                            </div>
                            {
                                submitted && !username &&
                                <div className="help-block">Username is required</div>
                            }
                        </div>
                        <div className={'form-group' + ((submitted && !password) ? ' has-error' : '')}>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><img src={passwordLogo} /></span>
                                </div>
                                <input type="password" placeholder="Password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                            </div>
                            {submitted && !password &&
                                <div className="help-block">Password is required</div>
                            }
                        </div>
                        {
                            logInMultiAccount? <div className={'form-group'}>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><img src={userLogo} /></span>
                                </div>
                                <input type="text" placeholder="Account number" className="form-control" name="accountId" value={accountId} onChange={this.handleChange} />
                            </div>
                        </div>:null
                        }

                        <div className="form-group signin-section text-center">
                            <button disabled={loggingIn} className="btn btn-primary blue-btn">
                                {
                                    loggingIn?<img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />:
                                    "Sign in"
                                }

                                </button>

                            {
                                hasError ? <div className="help-block">{error}</div> : null
                            }
                        </div>

                        <ModalFooter>
                            <div>
                                <p className="text-muted">
                                    <a href="https://my.easytrip.ie/ForgotPassword" target="_blank">
                                        Trouble signing in? 
                                    </a>
                                </p>
                            </div>
                        </ModalFooter>
                    </ModalBody>
                </form>
            </Modal>
        );
    }

}

UserLoginForm.propTypes = {
    actions: PropTypes.object.isRequired,
    loggingIn: PropTypes.bool,
    error: PropTypes.string,
    toggle: PropTypes.func.isRequired,
    isOpen:PropTypes.bool.isRequired,
    paymentActions:PropTypes.object,
    vehicleActions:PropTypes.object,
};

function mapStateToProps(state) {
    return {
        initialValues: state.authentication,
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
        vehicleList: state.vehicleList,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userActions, dispatch),
        paymentActions: bindActionCreators(paymentActions, dispatch),
        vehicleActions: bindActionCreators(vehicleActions, dispatch),
    };
}



export default connect(
    mapStateToProps,
    mapDispatchToProps
)(reduxForm({
    form: 'loginDetail',
    onSubmitSuccess: (result, dispatch, props) => {
        dispatch(initialize(props.form, props.values));
        if (this.state.cookiesAccepted) {
            ReactGA.event({
                category: 'account detail',
                action: 'change account detail'
            });
        }
    }
})(UserLoginForm));




// WEBPACK FOOTER //
// ./src/forms/UserLoginForm.jsx